import Accordion from '@visa/vds/accordion';
import AccordionBody from '@visa/vds/accordion-body';
import AccordionHeading from '@visa/vds/accordion-heading';
import AccordionItem from '@visa/vds/accordion-item';
import AccordionTitle from '@visa/vds/accordion-title';
import Td from '@visa/vds/td';
import Tr from '@visa/vds/tr';
import { DateHelper } from '_helpers/DateHelper';
import { PageHelper } from '_helpers/PageHelper';
import MCSOverlayLoading from 'components/MCSOverlayLoading';
import MCSPagedTable from 'components/MCSPagedTable';
import React, { useState } from 'react';
import { SubscriptionApi } from 'services/subscription.service';
import SubscriptionStatusBadge from 'components/subscription/SubscriptionStatusBadge';
import { SubscriptionHelper } from '_helpers/SubscriptionHelper';

function BillingDataSection(props) {
  const PAGE_SIZE = 10;
  const [orgProductSubscriptionsFetched, setOrgProductSubscriptionsFetched] = useState(false);
  const [orgProductSubscriptionsData, setOrgProductSubscriptionsData] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [ordered, setOrdered] = useState("");
  const bid = props.organization.bid;

  const handleTablePageChange = async (page, orderBy, desc) => {
    setOrgProductSubscriptionsFetched(false);
    let skipCount = PageHelper.GetSkipCount(PAGE_SIZE, page)

    const result = await SubscriptionApi.AdminOrganizationGetOrganizationProductSubcriptionList(skipCount, orderBy, desc, { bid: bid });
    const response = result.data;
    console.log('response: ', response);
    if (response) {
      setOrgProductSubscriptionsData(response.items);
      setTotalPages(PageHelper.GetTotalCountToPages(PAGE_SIZE, response.totalCount));
    }

    setOrgProductSubscriptionsFetched(true);
  }

  let colHeaders = [
    { displayName: "Purchased Date", name: "CreatedOn", orderable: true },
    { displayName: "Product Name", name: "ProductName", orderable: true },
    { displayName: "Subscription Name", name: "SubscriptionName", orderable: true },
    { displayName: "Subscription Start Date", name: "StartDate", orderable: true },
    { displayName: "Subscription Last Date", name: "EndDate", orderable: true },
    { displayName: "Order Reference", name: "OrderId", orderable: false },
    { displayName: "Purchased By", name: "CreatedBy", orderable: true },
    { displayName: "Status", name: "SubscriptionStatusName", orderable: false },
  ];

  const [selectedPage, setSelectedPage] = useState(1)
  const [isDsc, setDsc] = useState(false);

  const fetchDataOnPageChange = (page) => {
    setSelectedPage(page);
    handleTablePageChange(page, ordered, isDsc);
  }

  const sortData = async (orderBy = null, dsc = false) => {
    setOrdered(orderBy);
    setDsc(dsc);
    await handleTablePageChange(selectedPage, orderBy, dsc);
  }

  function getSubscriptionTypeDesc(subscriptionType) {
    let desc = SubscriptionHelper.GetSubscriptionTypeDescription(subscriptionType);
    if (desc != null && desc !== "") return " (" + desc + ")";
    return "";
  }

  React.useEffect(() => {
    handleTablePageChange(1);
  }, []);

    return (
    <>
        <Accordion id="accordion-billing-data">
          <AccordionItem>
            <AccordionHeading>
              <AccordionTitle>
                Billing/Transaction Data
              </AccordionTitle>
            </AccordionHeading>
            <AccordionBody>
              {!orgProductSubscriptionsFetched && <MCSOverlayLoading></MCSOverlayLoading>}
              <MCSPagedTable size={"compact"}
                colHeaders={colHeaders}
                usePagination={true}
                ordered={ordered}
                setOrdered={setOrdered}
                sortData={sortData}
                isDsc={isDsc}
                setDsc={setDsc}
                selectedPage={selectedPage} setSelectedPage={fetchDataOnPageChange} totalPages={totalPages}
                searchHelpText={"Order Reference"}
                tableData={
                  orgProductSubscriptionsData && orgProductSubscriptionsData.map((row, key) => (
                    <Tr key={key}>
                      <Td>{DateHelper.ToFormattedDate(row.createdOn)}</Td>
                      <Td>{row.productName}</Td>
                      <Td>
                        {row.subscriptionName +
                          getSubscriptionTypeDesc(row.subscriptionType)}
                      </Td>
                      <Td>{DateHelper.ToFormattedDate(row.startDate)}</Td>
                      <Td>{DateHelper.ToFormattedDate(row.endDate)}</Td>
                      <Td>{row.orderId}</Td>
                      <Td>{row.createdBy}</Td>
                      <Td class="word-nobreak">
                        <SubscriptionStatusBadge
                          startDate={row.startDate}
                          status={row.subscriptionStatus}
                          statusName={row.subscriptionStatusName}
                        />
                      </Td>
                    </Tr>
                  ))
                }
              />
            </AccordionBody>
          </AccordionItem>

        </Accordion>
    </>
    );
    
  }


export default BillingDataSection;
